import { dayjs } from '#gp/app-common/util/dayjs';
import { gpHome } from '../app';
import { IProjectService, IProject, ProjectServiceMessages } from '../../app-common/services/projects-service';
import { AccountsService } from '../services/accounts-service';
import { IAuthService } from '../services/auth-service';
import { gameplanProductConfiguration } from '../../app-common/product-configuration';

import type * as ng from 'angular';

interface gpWelcomeControllerScope extends ng.IScope {

    messageInfo: string;
    messageError: string;

    isCreatingNewPlan: boolean;
    isReadyToStartTutorial: boolean;
    isShowingWelcome: boolean;

    newPlanUrl: string;

    returnToPlanList(): void;
    openCreatedPlanOrGoToPlanList(): void;
}

class gpWelcomeController {
    planToOpen: IProject | null = null;

    constructor(
        public $scope: gpWelcomeControllerScope,
        private $location: ng.ILocationService,
        public projectsService: IProjectService,
        gpAccountsService: AccountsService,
        authService: IAuthService,
        private $timeout: ng.ITimeoutService) {

        let me = this;

        let authCheck = authService.checkAuthorisationIfNeeded();

        this.$scope.returnToPlanList = () => {
            this.$timeout(() => this.$location.path("/plans"), 100);
        }

        this.$scope.openCreatedPlanOrGoToPlanList = () => this.openCreatedPlanOrGoToPlanList();

        authCheck.then(authStatus => {
            if (authStatus.isAuthorised) {
                // We don't want to do anything special the first time someone logs in, so let's just navigate to plans.
                // The old code has been kept for future reference.
                this.$scope.returnToPlanList();

                //if (gpAccountsService.isNewlyRegistered(authStatus.email)) {
                //    this.$scope.isShowingWelcome = true;
                //    localStorage.setItem("__gameplan_wizard_first_time_user", "true");
                //    gpAccountsService.setAsNewlyRegisterdUser(authStatus.email, false);
                //    this.createPlanDontOpen()
                //} else {
                //    this.$location.path("/plans");
                //}
            }
        });

    }

    navigateToEditing(p: IProject) {
        let newurl = window.location.protocol + "//" + window.location.host + "/projects/" + p.id + "/edit";

        this.$scope.newPlanUrl = newurl;

        window.location.href = newurl;
    }

    openCreatedPlanOrGoToPlanList() {
        if (this.planToOpen) {
            this.navigateToEditing(this.planToOpen);
        } else {
            this.$scope.returnToPlanList();
        }
    }

    createPlanDontOpen() {
        this.$scope.isCreatingNewPlan = true;

        let newBoardName = "New Plan " + dayjs().format("dddd ll");

        this.$scope.messageInfo = "Creating plan...";

        let addRequest = this.projectsService.addProject(newBoardName, "", { startTutorial: true });

        addRequest.then(p => {
            this.planToOpen = p;
            this.$scope.messageInfo = "Plan created.";
            this.$scope.isReadyToStartTutorial = true;
        });

        addRequest.catch(reason => {
            if (reason === ProjectServiceMessages.UNAUTHORIZED) {
                this.$scope.messageInfo = "";
                const productName = gameplanProductConfiguration().productName;
                this.$scope.messageError = `You are not able to create a new plan right now. Please log out and then log in again. If this does not solve the issue, please contact ${productName} support.`;
            }

            this.$location.path("/plans");
        });

        addRequest.finally(() => {
            this.$scope.isCreatingNewPlan = false;
        })

        return addRequest;
    }

    createPlanAndOpen() {

        let addRequest = this.createPlanDontOpen();
        addRequest.then(p => {
            this.navigateToEditing(p);
        });
    }
}

gpHome.controller('gpWelcomeController', [
    '$scope',
    '$location',
    'projectsService',
    'accountsService',
    'authService',
    '$timeout',
    function (
        $scope: gpWelcomeControllerScope,
        $location: ng.ILocationService,
        projectsService: IProjectService,
        gpAccountsService: AccountsService,
        authService: IAuthService,
        $timeout: ng.ITimeoutService) {
        new gpWelcomeController($scope, $location, projectsService, gpAccountsService, authService, $timeout)
    }]);
